import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {PaginationInstance} from 'ngx-pagination';
import {FormBuilder, FormGroup, ValidatorFn, Validators} from '@angular/forms';
import {OverrideDefinitionType} from '../../../../../Models/enum/overrideDefinitionType';
import {WebClientConfigurationService} from '../../../../../services/configuration/web-client-configuration.service';
import {BpAdministrationService} from '../../../../../services/bp-administration.service';
import {CustomValidator} from '../../../../../services/custom-validator';
import {GenericModalService} from '../../../../../services/generic-modal.service';
import {ScheduleModalComponent} from '../schedule-modal/schedule-modal.component';
import {ReportsServiceService} from '../../../../../services/reports-service';
import {Observable, Subject} from 'rxjs';
import {take} from 'rxjs/operators';
import {BusinessProcessInstanceOverrideComponent} from '../business-process-instance-override.component';
import {UserModalComponent} from '../../../../Admin/users/user-modal.component';


@Component({
  selector: 'app-tab-intance-override',
  templateUrl: './tab-intance-override.component.html',
  styleUrls: ['../business-process-instance-override.component.css', '../../../../../styles/business-process-configuration.css']
})
export class TabIntanceOverrideComponent implements OnInit {

  @Output() schedulesEmit = new EventEmitter<boolean>();
  @Input() stateLifeCycles: Observable<any>;
  errorMessage = '';
  successMessage = '';
  pleaseWait = '';
  submitClick = false;
  public config: PaginationInstance;
  overrideForm: FormGroup;

  overrideTypes = [];
  eOverrideType = OverrideDefinitionType;
  bpList = [];
  stateList = [];
  lifeCycles = [];

  tdBpInstanceId = false;
  rowBp = false;
  tdStateTo = false;
  tdAutomaticAllocation = false; // Alocação automática
  /*tdCommomRules - (des)habilitar os campos:
  Ciclo de vida, Estado origem e Estado destino (quando o tipo de imposição não for Por Instância)*/
  tdCommomRules = false;
  tdPeriod = false;
  tdBackDays = false;

  currentDayInterval = function() {
    let now = new Date();
    return {
      start: new Date(Date.UTC(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0)).toISOString().substr(0, 16),
      end: new Date(Date.UTC(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59)).toISOString().substr(0, 16)
    };
  };

  get formData() { return this.overrideForm.controls; }

  constructor(private webClientConfig: WebClientConfigurationService, private bpAdmService: BpAdministrationService,
              private formBuilder: FormBuilder, private modalService: GenericModalService) { }

  ngOnInit() {
    this.createForm();

    this.loadOverrideType();
    this.loadBusinessProcesses();
    this.stateLifeCycles.subscribe(r => { this.lifeCycles = r; },
      error1 => this.errorMessage = error1);

    // habilitar os combos utilizados pelo tipo de imposição "Por Instâncias"
    this.selectOverrideType(this.eOverrideType.byInstance);

    this.getPaginationConfig();
  }

  createForm() {
    this.overrideForm = this.formBuilder.group({
      overrideType: 1,
      businessProcessInstanceId: null,
      businessProcessId: [ null, Validators.required ],
      stateFrom: null,
      stateTo: null,
      automaticAllocation: true,
      stateLifeCycle: null,
      initialDate: null,
      finalDate: null,
      backDays: null
    });
  }

  requestOverride() {
    this.errorMessage = '';
    this.successMessage = '';
    this.pleaseWait = 'Por favor, aguarde...';
    this.submitClick = true;

    const data = this.overrideForm.getRawValue();
    data.automaticAllocation = data.automaticAllocation == null ? false : data.automaticAllocation;
    const overrideType = parseInt(data.overrideType, 10);
    console.log(data);

    if (overrideType === this.eOverrideType.byInstance) {
      this.verifyInstanceId(data);
    } else if (overrideType === this.eOverrideType.byPeriod) {
      this.requestOverrideByPeriod(data);
    } else if (overrideType === this.eOverrideType.retroactive) {
      this.requestOverrideByRetroactive(data);
    }
  }

  onCreateScheduling() {
    const obj = this.overrideForm.getRawValue();
    obj.taskId = 0;
    obj.stateLifeCycle = obj.stateLifeCycle ? parseInt(obj.stateLifeCycle, 10) : null;
    const typeDescription = this.overrideTypes.filter(f => parseInt(obj.overrideType, 10) === f.value)
      .map(m => m.translatedName)[0];
    const businessProcessName = this.bpList.filter(f => parseFloat(obj.businessProcessId) === f.businessProcessId)
      .map(m => m.name)[0];

    const data = {
      overrideDefinition: {
        automaticAllocation: obj.automaticAllocation,
        backDays: obj.backDays ? parseInt(obj.backDays, 10) : null,
        businessProcessId: obj.businessProcessId,
        businessProcessInstanceId: obj.businessProcessInstanceId,
        businessProcessName: businessProcessName,
        finalDate: obj.overrideType === '2' ? obj.finalDate : null,
        fromStateLifeCycle: obj.stateLifeCycle,
        fromStateName: obj.stateFrom,
        id: 0,
        initialDate: obj.overrideType === '2' ? obj.initialDate : null,
        name: null,
        toStateName: obj.stateTo,
        type: parseInt(obj.overrideType, 10),
        typeDescription: typeDescription,
        userId: 0
      },
      stateLifeCycles: this.lifeCycles
    };

    const destComponent: any = ScheduleModalComponent;
    const result$ = this.modalService.showObjModal(destComponent, 'Configurar Agendamento', data);
    if (result$) {
      result$.asObservable()
      // .pipe(take(1))
        .subscribe((result) => {
          // devolver para a tela principal, se deve ou nao atualizar a aba de agendamento
          this.schedulesEmit.emit(result);
        });
    } else {
      this.errorMessage = 'Erro: Sessão expirada.';
    }
  }

  verifyInstanceId(data) {
    this.errorMessage = '';
    this.bpAdmService.verifyInstaceId(data.businessProcessId, data.businessProcessInstanceId)
      .subscribe(isValid => {
        if (isValid) {
          this.requestOverrideByInstanceId(data.businessProcessInstanceId, data.stateTo, data.automaticAllocation);
        } else {
          this.pleaseWait = '';
          this.errorMessage = 'ID da instância informado não pertence ao Processo de Negócio selecionado';
          this.submitClick = false;
        }
      }, error1 =>  {
        this.errorMessage = error1;
        this.pleaseWait = '';
        this.submitClick = false;
      });
  }

  requestOverrideByInstanceId(businessProcessInstanceId, toStateName, automaticAllocation) {
    this.errorMessage = '';
    this.bpAdmService.requestOverrideInstanceById(businessProcessInstanceId, toStateName, automaticAllocation)
      .subscribe(overrideInfo => {
        this.pleaseWait = '';
        if (overrideInfo == null || overrideInfo.status === 1) {
          this.successMessage = `Imposição da instância ${businessProcessInstanceId} requisitada com sucesso para o estado "${toStateName}" <br>
            Para consultar se houve falha na execução, acesse o relatório Imposições Irregulares.`;

          setTimeout( () => {
            this.successMessage = '';
          }, 10000);
        } else {
          this.errorMessage = `Erro ao requisitar a imposição da instância ${businessProcessInstanceId} para o estado "${toStateName}" <br> ${overrideInfo.errorMessage}`;
        }
        this.submitClick = false;
      }, error1 => {
        this.pleaseWait = '';
        this.errorMessage = error1;
        this.submitClick = false;
      });
  }

  requestOverrideByPeriod(data) {
    const requestParams = {
      businessProcessId: data.businessProcessId,
      stateLifeCycle: parseInt(data.stateLifeCycle, 10),
      fromStateName: data.stateFrom,
      toStateName: data.stateTo,
      initialDate: new Date(data.initialDate).toISOString(),
      finalDate: new Date(data.finalDate).toISOString(),
      automaticAllocation: data.automaticAllocation == null ? false : data.automaticAllocation
    };

    this.errorMessage = '';

    this.bpAdmService.requestOverrideInstanceByPeriod(requestParams)
      .subscribe(affectedInstances => {
        this.pleaseWait = '';
        if (affectedInstances === 0) {
          this.errorMessage = 'Não foram encontradas instâncias que atendam aos critérios solicitados.';
        } else {
          this.successMessage = `Imposição requisitada para ${affectedInstances} instância(s) de Processo de Negócio com sucesso. <br>
            Para consultar se houve falha em alguma imposição, acesse o relatório Imposição de Instâncias.`;
        }

        this.submitClick = false;
        setTimeout( () => {
          this.errorMessage = '';
          this.successMessage = '';
        }, 10000);
      }, error1 =>  {
        this.pleaseWait = '';
        this.errorMessage = error1;
        this.submitClick = false;
      });
  }

  requestOverrideByRetroactive(data) {
    const requestParams = {
      businessProcessId: data.businessProcessId,
      stateLifeCycle: parseInt(data.stateLifeCycle, 10),
      fromStateName: data.stateFrom,
      toStateName: data.stateTo,
      backDays: parseFloat(data.backDays),
      automaticAllocation: data.automaticAllocation == null ? false : data.automaticAllocation
    };

    this.errorMessage = '';
    this.bpAdmService.requestOverrideInstanceByRetroactive(requestParams)
      .subscribe(affectedInstances => {
        this.pleaseWait = '';
        if (affectedInstances === 0) {
          this.errorMessage = 'Não foram encontradas instâncias que atendam aos critérios solicitados.';
        } else {
          this.successMessage = `Imposição requisitada para ${affectedInstances} instância(s) de Processo de Negócio com sucesso. <br>
            Para consultar se houve falha em alguma imposição, acesse o relatório Imposição de Instâncias.`;
        }

        this.submitClick = false;
        setTimeout( () => {
          this.errorMessage = '';
          this.successMessage = '';
        }, 10000);
      }, error1 => {
        this.pleaseWait = '';
        this.errorMessage = error1;
        this.submitClick = false;
      });
  }

  periodKeyDown() {
    return false;
  }

  cleanFields() {
    this.errorMessage = '';
    this.successMessage = '';
    this.submitClick = false;
    this.pleaseWait = '';

    const overrideType = this.overrideForm.get('overrideType').value;
    this.overrideForm.reset();
    this.overrideForm.controls.overrideType.setValue(overrideType);
    this.selectOverrideType(overrideType);
  }

  loadOverrideType() {
    this.errorMessage = '';
    this.bpAdmService.getOverrideDefinitionTypes().subscribe(r => {
      this.overrideTypes = r;
    }, error1 => this.errorMessage = error1);
  }

  loadBusinessProcesses() {
    const selectedOverrideType = parseInt(this.overrideForm.get('overrideType').value, 10);
    this.errorMessage = '';
    this.pleaseWait = 'Carregando filtro... Por favor aguarde.';
    this.bpAdmService.getBusinessProcessesOverride().subscribe(res => {
        this.bpList = res;
        this.rowBp = true;
        // habilitar/desabilitar o campo id da instância
        this.requiredInstanceId(selectedOverrideType, res && res.length > 0);
        this.pleaseWait = '';
      },
      error1 => {
        this.pleaseWait = '';
        this.errorMessage = error1;
      });
  }

  loadStates(businessProcessId) {
    this.errorMessage = '';
    this.pleaseWait = 'Carregando filtro... Por favor aguarde.';
    this.stateList = [];
    this.overrideForm.patchValue({
      stateTo: null,
      stateFrom: null
    });
    this.overrideForm.get('stateTo').updateValueAndValidity();
    this.overrideForm.get('stateFrom').updateValueAndValidity();

    this.bpAdmService.getStatesOverride(businessProcessId)
      .subscribe(res => {
        this.stateList = res;
        this.pleaseWait = '';
      }, error1 => {
        this.pleaseWait = '';
        this.errorMessage = error1;
      });
  }

  selectOverrideType(element) {
    const selectedOverrideType = parseInt(element, 10);

    // deve-se sempre esconder os campos, quando muda o tipo de imposição
    this.tdStateTo = false;
    this.tdAutomaticAllocation = false;
    this.requiredCommomFields(selectedOverrideType, false);

    // habilitar/desabilitar o campo id da instância
    this.requiredInstanceId(selectedOverrideType, this.bpList && this.bpList.length > 0);
    this.requiredPeriod(selectedOverrideType);
    this.requiredBackDays(selectedOverrideType);

    this.overrideForm.patchValue({
      businessProcessInstanceId: null,
      businessProcessId: null,
      stateFrom: null,
      stateTo: null,
      automaticAllocation: true,
      stateLifeCycle: null,
      initialDate: this.currentDayInterval().start,
      finalDate: this.currentDayInterval().end,
      backDays: null
    });
  }

  changeBusinessProcess(element) {

    if (element !== undefined) {
      let bpId = parseFloat(element.businessProcessId);
      bpId = isNaN(bpId) ? 0 : bpId;
      const isSelectedBp = bpId > 0;

      const selectedOverrideType = parseInt(this.overrideForm.get('overrideType').value, 10);

      // habilitar/desabilitar os campos
      this.requiredInstanceId(selectedOverrideType, this.bpList.length > 0);
      this.requiredStateTo(isSelectedBp);
      this.tdAutomaticAllocation = bpId > 0;
      this.requiredPeriod(selectedOverrideType);
      this.requiredCommomFields(selectedOverrideType, isSelectedBp);
      this.requiredBackDays(selectedOverrideType);
      this.loadStates(bpId);

      this.overrideForm.get('stateTo').enable();
      this.overrideForm.get('stateFrom').enable();
    } else {
      this.stateList = [];
      this.overrideForm.patchValue({stateTo: null, stateFrom: null});
      this.overrideForm.get('stateTo').disable();
      this.overrideForm.get('stateFrom').disable();
    }
  }

  requiredPeriod(selectedOverrideType) {
    this.tdPeriod = selectedOverrideType === this.eOverrideType.byPeriod;
    if (this.tdPeriod) {
      this.addOrRemoveValidators('initialDate', Validators.required);
      this.addOrRemoveValidators('finalDate', Validators.required);
      this.overrideForm.setValidators(CustomValidator.validateDatetime('initialDate', 'finalDate'));
    } else {
      this.addOrRemoveValidators('initialDate');
      this.addOrRemoveValidators('finalDate');
      this.overrideForm.clearValidators();
    }
    this.overrideForm.updateValueAndValidity();
  }

  requiredBackDays(selectedOverrideType) {
    this.tdBackDays = selectedOverrideType === this.eOverrideType.retroactive;
    if (this.tdBackDays) {
      this.addOrRemoveValidators('backDays', [CustomValidator.numeric, Validators.maxLength(5)]);
    } else {
      this.addOrRemoveValidators('backDays');
    }
  }

  requiredInstanceId(selectedOverrideType, isBpList) {

    // verificar pq quando verifica se o tdBp desconfigura a formatação de obrigatório ao carregar a tela na primeira vez.
    // quando clica no campo, o campo volta a ficar com a linha vermelha
    this.tdBpInstanceId = selectedOverrideType === this.eOverrideType.byInstance && isBpList;

    if (this.tdBpInstanceId) {
      this.addOrRemoveValidators('businessProcessInstanceId',
        [CustomValidator.numeric, Validators.maxLength(50)]);
    } else {
      this.addOrRemoveValidators('businessProcessInstanceId');
    }
  }

  requiredStateTo(isSelectedBp) {
    this.tdStateTo = isSelectedBp;
    if (this.tdStateTo) {
      this.addOrRemoveValidators('stateTo', Validators.required);
    } else {
      this.addOrRemoveValidators('stateTo');
    }
  }

  requiredCommomFields(selectedOverrideType, isSelectedBp) {
    this.tdCommomRules = selectedOverrideType !== this.eOverrideType.byInstance && isSelectedBp;

    if (this.tdCommomRules) {
      this.addOrRemoveValidators('stateFrom', Validators.required);
      this.addOrRemoveValidators('stateLifeCycle', Validators.required);
    } else {
      this.addOrRemoveValidators('stateFrom');
      this.addOrRemoveValidators('stateLifeCycle');
    }
  }

  addOrRemoveValidators(formControlName, newValidator: ValidatorFn | ValidatorFn[] | null = null) {
    if (newValidator === null) {
      this.overrideForm.get(formControlName).clearValidators();
    } else {
      this.overrideForm.get(formControlName).setValidators(newValidator);
    }
    this.overrideForm.get(formControlName).updateValueAndValidity();
  }

  getPaginationConfig() {
    this.errorMessage = '';
    this.webClientConfig.getPageSizeConfig().subscribe(item => {
      this.config  = {
        id: 'custom',
        itemsPerPage: item,
        currentPage: 1
      };
    }, error1 => this.errorMessage = error1);
  }

}
